<ng-container *ngIf="imageBlob$ | async as image; else spinner">
  <img [src]="image" />
</ng-container>
<ng-template #spinner>
  <sv-loading-spinner></sv-loading-spinner>
</ng-template>

